import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import AnalyticsComponent from '../components/AnalyticsComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';

class ProductAnalyticsPage extends Component {

	constructor(){
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
            itemName: '',
        }
	}

	async componentDidMount() {
        let role = await validateSession(true)
        this.setState({ checked: true, role: role });
    }

    getSearchParams = () => {
        return new URLSearchParams(this.props.location.search || '');
    }

    getProductCode = () => {
        return this.getSearchParams().get('code') || '';
    }

    getSidebarItemSelected = () => {
        const source = this.getSearchParams().get('source');

        if (source === 'soldProducts') {
            return 16;
        }

        if (source === 'products') {
            return 4;
        }

        return 4;
    }

	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div class="container-fluid">
                    <div class="row">
                        <SidebarComponent itemSelected={this.getSidebarItemSelected()} role={this.state.role}/>
                        <main class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4">
                                <HeaderComponent
                                    title="Productos"
                                    subtitle={this.state.itemName || 'Analytics del producto'}
                                />
                                <AnalyticsComponent
                                    code={ this.getProductCode() }
                                    role={this.state.role}
                                    onItemNameChange={(itemName) => this.setState({ itemName })}
                                />
                            </div>
                        </main>
                    </div>
                </div>
            );
        }
    }
}

export default ProductAnalyticsPage;
